import { Collection, CollectionContent } from '@/types/collection.types';
import { IItem } from '@/types/feed.types';

import { ECardSizes, IPreviewCard } from './PreviewCard.types';
import { CollectionCard } from './subcomponents/CollectionCard';
import { ItemCard } from './subcomponents/ItemCard';

function isCollection(
  data: IItem | Collection | CollectionContent | null,
): data is Collection {
  return data !== null && 'items' in data;
}
export const PreviewCard: React.FC<IPreviewCard> = ({
  data,
  size = ECardSizes.S,
  innerRef,
  playlistId = null,
  searchString = null,
  collectionId = null,
  isHome = false,
  cardTitle,
  showCreatedTime = true,
  showMetadata = true,
  priority = false,
  previewSource,
}) => {
  if (isCollection(data)) {
    return <CollectionCard data={data} innerRef={innerRef} />;
  }

  return (
    <ItemCard
      data={data}
      size={size}
      innerRef={innerRef}
      playlistId={playlistId}
      searchString={searchString}
      isHome={isHome}
      collectionId={collectionId}
      cardTitle={cardTitle}
      showCreatedTime={showCreatedTime}
      showMetadata={showMetadata}
      priority={priority}
      previewSource={previewSource}
    />
  );
};
